import React, { useRef, useEffect, useCallback } from 'react';
import './websocketVideoPlayer.scss';
import moment from 'moment';

export default function WebSocketVideoPlayer(props) {
    const {
        camera,
        height,
        id = null,
        refs = null,
        videoKey = null,
        channelKey = null,
        isLive = true,
        onReady = null,
        onRemoved = null,
    } = props;
    const videoRefs = useRef({});
    const iframeRef = useRef(null);
    const selfRef = useRef({
        _isSeeking: false,
        play: () => {
            if (iframeRef?.current?.contentWindow && !selfRef._isSeeking) {
                iframeRef.current.contentWindow.postMessage({ 'action': 'play' }, '*');
            }
        },
        pause: () => {
            if (iframeRef?.current?.contentWindow && !selfRef._isSeeking) {
                iframeRef.current.contentWindow.postMessage({ 'action': 'pause' }, '*');
            }
        },
        _currentTime: 0,
        _s: 0,
        get currentTime() {
            return this._currentTime;
        },
        set currentTime(val) {
            this._currentTime = val;
            //will reimplement when quirk is fixed
            // if (iframeRef?.current?.contentWindow && !this._isSeeking) {
            //     this._isSeeking = true;
            //     iframeRef.current.contentWindow.postMessage({ 'action': 'seek', 'time': val }, '*');
            // }
        }
    });
    useEffect(() => {
        function handleMessage(event) {
            if (event.data && event.data.type === 'TIMESTAMP' && event.data.videoId === id && !selfRef.current._isSeeking) {
                selfRef.current._currentTime = event.data.timestamp; // This will trigger handleCurrentTimeChange
                selfRef.current._s = event.data.timestamp; // This will trigger handleCurrentTimeChange
            }
            if (event.data && event.data.type === 'VIDEO_READY' && event.data.videoId === id) {
                if (onReady) {
                    onReady(event.data.videoId);
                }
            }
            if (event.data && event.data.type === 'SEEK' && event.data.videoId === id) {
                selfRef.current._isSeeking = false;
            }
        }

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
            if (onRemoved) {
                onRemoved(id);
            }
        };
    }, [selfRef]);

    const createVideoRef = useCallback((ref, video_id) => {
        if (ref && video_id && !videoRefs.current[video_id]) {
            if (selfRef && channelKey !== null && (!refs[channelKey]) || (refs[channelKey]?.element !== selfRef.current)) {
                refs[channelKey] = { key: videoKey, element: selfRef.current };
            }
            videoRefs.current[video_id] = selfRef;
        }
    }, [onReady]);

    let queryParams = {
        websocket_payload: camera.websocket_payload,
        websocket_url: camera.websocket_url,
        video_id: id || '',
        is_live: isLive,
    };
    if (!isLive) {
        queryParams.file_begin = camera.fileBegin;
        queryParams.begin_time = camera.beginTime;
        queryParams.file_end = camera.fileEnd;
        queryParams.start_timestamp = moment(camera.start_time).valueOf();
    }

    const queryString = new URLSearchParams(queryParams).toString();

    let src = `/websocket-player.html?${queryString}`;

    return (
        <div
            className="mainContainer websocketVideoPlayer"
            style={{
                width: '100%',
                height: '100%',
                minHeight: '230px',
            }}
            ref={(ref) => {
                createVideoRef(ref, id);

            }}
        >
            <iframe
                allowFullScreen
                title="historic_video_iframe"
                width="100%"
                height="inherit"
                frameBorder={0}
                scrolling="no"
                style={{ margin: '0 auto', overflow: 'hidden', minHeight: `${height}px` }}
                src={src}
                ref={(ref) => {
                    if (ref && iframeRef.current !== ref) {
                        iframeRef.current = ref;
                    }
                }}
            />
            {/* <Spinner loading={loading} minHeight={200}> // will be looking at reimplementing loading state later
                <video
                    ref={ref => {
                        console.log('new ref for video', id, ref);
                        createVideoRef(ref, id);
                        if (refs && channelKey) {
                            refs[channelKey] = { key: videoKey, element: ref };
                        }
                    }}
                    className="centeredVideo"
                    id={id}
                    autoPlay={isLive}
                    playsInline
                    muted={isLive}
                    style={{ width: '100%', height: '100%', minHeight: '175px', display: !videoAvailable ? 'none' : 'block' }}
                >
                    Your browser is too old which doesn't support HTML5 video.
                </video>
                <div
                    ref={noVideoOverlayRef}
                    className='no-video-overlay'
                    style={{ width: '100%', height: '100%', minHeight: '175px', display: videoAvailable ? 'none' : 'flex' }}>
                    <div className='no-video-text' style={{ fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}>
                        Video Unavailable <a onClick={retryClick} style={{ marginLeft: '12px', textDecoration: 'underline' }}>Retry</a>
                    </div>
                </div>
            </Spinner> */}
        </div>
    );
}